import { useContext } from "react";
import {Container} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import styles from "../Footer.module.scss";
import AppConfigContext from "../../context/AppConfigContext";
import { getCurrentYear } from "../../utils/utils";

const FormFooter = () => {
    const { config } = useContext(AppConfigContext);
    const { t } = useTranslation(config.theme, { keyPrefix: "footer" });
    const { meta, copyright } = config.footer;
    const copyrightText = config.isMultiLingual ? t("copyright", { year: getCurrentYear() }) : copyright;

    return (
        <footer className={`py-3 ${styles.footer}`}>
            <Container>
                <p className="small text-muted mb-0 lh-base">{copyrightText}</p>
                {meta?.materialId && <span className="d-block small text-muted mt-1">{meta.materialId}</span>}
                {meta?.materialSubtext && <span className="d-block small text-muted mt-1">{meta.materialSubtext}</span>}
            </Container>
        </footer>
    )
}

export default FormFooter;
